import React from 'react'
import DocSearchContainer from '../../../view/cmn/docSearch/DocSearchContainer';
import SarasModal from '../../container/popup/SarasModal';
import SarasDialog from '../../container/popup/SarasDialogDefAction';

const FormSearch = (props) => {
    const { enableSelect, onSaveClick, onCancelClick, docTypeId, initCriteria } = props
    const [selectedKeys, setSelectedKeys] = React.useState([])

    const initialConfig={ "initialCriteria":initCriteria, "resetCriteria":1 }


    const actionFun = () => {
        if (onSaveClick) onSaveClick(selectedKeys)
    }

    const closeFun = () => {
        if (onCancelClick) onCancelClick()
    }

    return (
        <SarasModal enableModal={true} modelState={true} onModalClose={closeFun} >
            <SarasDialog formStyle={{ width: '80vW' }} title='Select Item'
                actionName='Confirm' actionFunction={actionFun} cancelName='Cancel' cancelFunction={closeFun} 
                contentStyle={{height:'500px', overflowY: 'scroll' }}
                >
                <DocSearchContainer enableSelect={enableSelect} enableDefaultActions={false} onSelectedRowsChange={setSelectedKeys} docTypeId={docTypeId} initialConfig={initialConfig} />
            </SarasDialog>
        </SarasModal>
    )
}

export default FormSearch